import React from "react";
import GeneralForm from "./GeneralForm/GeneralForm";
import WebhooksForm from "./WebhooksForm/WebhooksForm";
import PasswordSecurityForm from "./PasswordSecurityForm/PasswordSecurityForm";
import { IManagementStore } from "@src/Stores/Management/types";
import { inject, observer } from "mobx-react";
import { observable } from "mobx";
import AppPreloader from "@src/Components/Common/AppPreloader/AppPreloader";
import { STTabsContentWrapper, STFormContentWrapper } from "./styles";
import { Grid, Tabs, Tab } from "@material-ui/core";
import { Values } from "@src/Tools/Values";
import STPageHeader from "@src/Components/Ui/STPageHeader";

interface IProps {
  management?: IManagementStore;
}

@inject("management")
@observer
export default class Options extends React.Component<IProps> {
  @observable isLoading: boolean = true;
  @observable tabIndex: number = 0;

  async componentDidMount() {
    await this.props.management.getOptions();
    this.isLoading = false;
    document.title = Values.getLocalizationValue("options");
  }

  handleTabIndexChange = (event: React.ChangeEvent<{}>, newValue: number) => {
    this.tabIndex = newValue;
  };

  render() {
    if (this.isLoading) {
      return <AppPreloader />;
    }
    const { management } = this.props;
    const initialValues = {
      webhooks: management.options.webhooks,
      minPasswordLength: management.options.minPasswordLength,
      needUpperCaseLowerCase: management.options.needUpperCaseLowerCase,
      needSpecialChars: management.options.needSpecialChars,
      tokenExpireTimeHours: management.options.tokenExpireTimeHours,
      allowToSetupMultipleAssigns: management.options.allowToSetupMultipleAssigns,
      isTwoFactorAuthenticationRequiredForElevatedPermissions: management.options.isTwoFactorAuthenticationRequiredForElevatedPermissions
    };
    return (
      <Grid container justify="center">
        <Grid item xs={12}>
          <STPageHeader>{Values.getLocalizationValue("options")}</STPageHeader>
        </Grid>
        <STTabsContentWrapper>
          <Tabs
            value={this.tabIndex}
            onChange={this.handleTabIndexChange}
            indicatorColor="primary"
            textColor="primary"
            variant="fullWidth"
          >
            <Tab label={Values.getLocalizationValue("general")} />
            <Tab label={Values.getLocalizationValue("webhooks")} />
            <Tab label={Values.getLocalizationValue("passwordSecurity")} />
          </Tabs>
          <STFormContentWrapper>
            {this.tabIndex === 0 && (
              <div>
                <GeneralForm initialValues={initialValues} />
              </div>
            )}
            {this.tabIndex === 1 && (
              <div>
                <WebhooksForm initialValues={initialValues} />
              </div>
            )}
            {this.tabIndex === 2 && (
              <div>
                <PasswordSecurityForm initialValues={initialValues} />
              </div>
            )}
          </STFormContentWrapper>
        </STTabsContentWrapper>
      </Grid>
    );
  }
}
